export default __webpack_public_path__ + "static/media/com-foto3.28a9669f.jpg";